import Icon from '../components/Icon.vue'

Icon.register({"space-shuttle":{"width":640,"height":512,"paths":[{"d":"M592.6 208.2C559.7 192.8 515.8 184 472 184H186.3C181.4 177.4 175.7 172 169.6 168H376C229.2 137.7 219.4 32 96 32H96V160H80V32C53.5 32 32 60.7 32 96V160C8.8 160 0 170 0 184V224C0 238 8.8 248 32 248V264C8.8 264 0 274 0 288V328C0 342 8.8 352 32 352V416C32 451.3 53.5 480 80 480V352H96V480H96C219.4 480 229.2 374.3 376 344H169.6C175.7 340 181.4 334.6 186.3 328H472C515.8 328 559.7 319.2 592.6 303.8 622.3 289.8 640 272 640 256S622.3 222.2 592.6 208.2zM488 296A8-8 0 0 0 480 288V224A8-8 0 0 0 488 216C519.9 216 519.9 296 488 296z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/space-shuttle.js
// module id = xmKG
// module chunks = 0